document.addEventListener("DOMContentLoaded", function () {
  class YGCopy extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      // 这里放置初始化逻辑
      this.clickCopy();
    }

    clickCopy() {
      let $button = this.querySelector(".yg-copy__button");
      $button.addEventListener("click", () => {
        let $copyContent = this.querySelector("[data-product-sku]");
        let copyContent = $copyContent.innerText;
        let copyText = copyContent.split("SKU: ")[1];

        navigator.clipboard.writeText(copyText).then(
          () => {
            $copyContent.innerHTML = "COPY SUCCESS !";
            setTimeout(() => {
              $copyContent.innerHTML = copyContent;
            }, 3000);
          },
          () => {
            $copyContent.innerHTML = "COPY FAILURE !";
            setTimeout(() => {
              $copyContent.innerHTML = copyContent;
            }, 3000);
          }
        );
      });
    }
  }
  if (!window.customElements.get("yg-copy")) {
    window.customElements.define("yg-copy", YGCopy);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      // 这里放置初始化逻辑
      this.toggleAccordion();
    }
    toggleAccordion() {
      // 这里放置自定义逻辑
      // title: title元素
      // content: content元素
      let _this = this;
      let title = this.querySelector(".yg-accordion-header");
      let content = this.querySelector(".yg-accordion-content");

      title.addEventListener("click", function () {
        let height = 0;
        if (content.classList.contains("active")) {
          height = content.getBoundingClientRect().height;
          content.style.height = `${height}px`;
          content.getBoundingClientRect();
          content.style.height = 0;

          _this.classList.remove("active");
          content.classList.remove("active");
        } else {
          content.style.height = "auto";
          height = content.getBoundingClientRect().height;
          content.style.height = 0;
          content.getBoundingClientRect();
          content.style.height = `${height}px`;

          _this.classList.add("active");
          content.classList.add("active");
        }
      });
    }
  }
  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  class YGProductBundle extends HTMLElement {
    static variantIds = [];
    static currency = "";
    constructor() {
      super();
      this.init();
      YGProductBundle.currency =
        this.querySelector("[data-total-price]").innerText.split("0.00")[0];
    }
    init() {
      // 这里放置初始化逻辑
      this.initSwiper();
      this.selectProduct();
      this.addToCart();
    }
    initSwiper() {
      // 这里放置自定义逻辑
      new Swiper(this, {
        slidesPerView: 4,
        spaceBetween: 60,
        breakpoints: {
          //当swiper宽度大于等于768
          1200: {
            slidesPerView: 4,
            spaceBetween: 60,
          },
          900: {
            slidesPerView: 2.9,
            spaceBetween: 60,
          },
          500: {
            slidesPerView: 2.3,
            spaceBetween: 60,
          },
          300: {
            slidesPerView: 1.7,
            spaceBetween: 60,
          },
        },
      });
    }

    selectProduct() {
      let _this = this;
      let $productItems = this.querySelectorAll(".product-bundle__item");

      $productItems.forEach((item) => {
        item.addEventListener("click", () => {
          item.classList.toggle("active");
          _this.calculatePrice();
        });
      });
    }

    calculatePrice() {
      let $activeProducts = this.querySelectorAll(
        ".product-bundle__item.active"
      );

      let $productTotalPrice = this.querySelector("[data-total-price]"),
        $productTotalComparePrice = this.querySelector(
          "[data-total-compare-price]"
        ),
        $productDiscount = this.querySelector("[data-total-discount]"),
        $addToCart = this.querySelector(".product-bundle-bottom__button");

      let totalPrice = 0,
        totalComparePrice = 0;

      YGProductBundle.variantIds = [];
      if ($activeProducts.length > 0) {
        $activeProducts.forEach((activeProduct) => {
          YGProductBundle.variantIds.push({
            id: activeProduct.dataset.variantId,
            quantity: "1",
          });

          let $productPrice = activeProduct.querySelector("[data-price]");
          let $productComparePrice = activeProduct.querySelector(
            "[data-compare-price]"
          );

          $productPrice &&
            (totalPrice += parseFloat($productPrice.dataset.price));
          $productComparePrice &&
            (totalComparePrice += parseFloat(
              $productComparePrice.dataset.comparePrice
            ));

          $productTotalPrice.innerText =
            YGProductBundle.currency + (totalPrice / 100).toFixed(2);
          $addToCart.classList.add("active");
          if (totalComparePrice > totalPrice) {
            $productTotalComparePrice.innerText =
              YGProductBundle.currency + (totalComparePrice / 100).toFixed(2);
            $productDiscount.innerText =
              "Save " +
              YGProductBundle.currency +
              ((totalComparePrice - totalPrice) / 100).toFixed(2);
            $productTotalComparePrice.classList.remove("hide");
            $productDiscount.classList.remove("hide");
          } else {
            $productTotalComparePrice.innerText = "";
            $productDiscount.innerText = "";
            $productTotalComparePrice.classList.add("hide");
            $productDiscount.classList.add("hide");
          }
        });
      } else {
        $productTotalPrice.innerText = YGProductBundle.currency + "0.00";
        $addToCart.classList.remove("active");
        $productTotalComparePrice.innerText = "";
        $productDiscount.innerText = "";
      }
    }

    addToCart() {
      let _this = this;
      let $addToCart = this.querySelector(".product-bundle-bottom__button");

      $addToCart.addEventListener("click", () => {
        if (!$addToCart.classList.contains("active")) {
          return;
        }

        let productData = {
          items: YGProductBundle.variantIds,
          sections: "",
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(productData),
        }).then(async (response) => {
          if (response.ok) {
            // 此位置代码为更新模板页面，根据不同模板代码不同

            let headerID =
                document.querySelector("header.header").dataset.sectionId,
              quickCartID =
                document.querySelector(".quick-cart").dataset.sectionId;

            let headerUpdate = ["[data-header-cart]"],
              quickCartUpdate = [
                ".quick-cart .quick-cart__heading",
                ".quick-cart .quick-cart__form",
              ];

            let headerDoc = await _this.requestSectionHTML(headerID),
              quickCartDoc = await _this.requestSectionHTML(quickCartID);

            document
              .querySelector(".quick-cart .quick-cart__wrapper")
              .classList.add("active");

            _this.updateHTMl(headerUpdate, headerDoc);
            _this.updateHTMl(quickCartUpdate, quickCartDoc);
          }
        });
      });
    }

    requestSectionHTML = async (sectionId) => {
      // sectionId shopify渲染的id

      return fetch(`/?sections=${sectionId}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error("网络响应不正常");
          }
          return res.text();
        })
        .then((data) => {
          // 从响应中解析出所需的部分
          let parsedData = JSON.parse(data);
          let sectionData = parsedData[sectionId];

          if (!sectionData) {
            throw new Error(`未能找到指定的 section: ${sectionId}`);
          }

          return sectionData;
        });
    };

    updateHTMl = (className, doc) => {
      let $div = document.createElement("div");

      $div.innerHTML = doc;
      if (Array.isArray(className)) {
        className.forEach((name) => {
          let $old = document.querySelector(name);
          let $new = $div.querySelector(name);
          $old.innerHTML = $new.innerHTML;
        });
      } else {
        let $old = document.querySelector(className);
        let $new = $div.querySelector(className);
        $old.innerHTML = $new.innerHTML;
      }
    };
  }
  if (!window.customElements.get("yg-product-bundle")) {
    window.customElements.define("yg-product-bundle", YGProductBundle);
  }

  class YGAnchorTab extends HTMLElement {
    constructor() {
      super();
      this.scrollTimer = null;
      this.init();
    }
    init() {
      let $sectionBox = this.closest(".yg-anchor-section");
      this.calculateTopValue($sectionBox);
    }

    intersectionObserver($ygProductTabList) {
      const options = {
        rootMargin: "-30%",
        threshold: [0.1],
      };

      const intersectionObserver = new IntersectionObserver((entries) => {
        // 判断进入页面范围
        if (entries[0].intersectionRatio > 0.1) {
          $ygProductTabList.forEach((productTab) => {
            if (
              entries[0].target.getAttribute("data-section-number") ==
              productTab.getAttribute("data-section-number")
            ) {
              this.removeClassName($ygProductTabList);
              // 给当前项添加激活类
              productTab.classList.add("active");
            }
          });
        }
      }, options);

      return intersectionObserver;
    }

    toggleClassName(sectionTop, sectionBox, className) {
      clearTimeout(this.scrollTimer);

      // 设置新的定时器
      this.scrollTimer = setTimeout(function () {
        // 在页面滚动停止后执行的操作
        if (sectionTop < window.scrollY) {
          sectionBox.classList.add(className);
        } else {
          sectionBox.classList.remove(className);
        }
      }, 150); // 这里的 150 是延迟时间，单位为毫秒
    }

    removeClassName($domList) {
      $domList.forEach(($dom) => {
        $dom.classList.remove("active");
      });
    }

    calculateTopValue(sectionBox) {
      let _this = this;
      let sectionTop =
        sectionBox.nextElementSibling.getBoundingClientRect().top +
        window.scrollY;

      let $ygSectionList = document.querySelectorAll("#main .shopify-section"),
        $ygProductTabList = this.querySelectorAll("span");

      let intersectionObserver = this.intersectionObserver($ygProductTabList);

      // 开始观察
      $ygSectionList.forEach(function (Section, i) {
        // 给每个Section添加data-section-number属性
        Section.setAttribute("data-section-number", i);
        intersectionObserver.observe(Section);
      });

      $ygProductTabList.forEach(function (e) {
        e.onclick = function () {
          // 获取点击项的data-section-number属性值
          let number = e.getAttribute("data-section-number");
          // 移除所有激活类
          _this.removeClassName($ygProductTabList);
          // 给当前点击项添加激活类
          e.classList.add("active");
          if (number) {
            // 遍历ygSectionList，停止观察
            $ygSectionList.forEach(function (Section) {
              intersectionObserver.unobserve(Section);
            });

            // 通过属性值获取dom节点
            let pointDom = $ygSectionList[number];
            // 计算滚动距离
            let pointTop =
              pointDom.offsetTop -
              sectionBox.getBoundingClientRect().height -
              80; // 80为导航栏高度
            // 滑动到指定dom节点
            window.scrollTo({
              top: pointTop,
              behavior: "smooth",
            });

            // 遍历ygSectionList，延时500ms后重新开始观察
            setTimeout(function () {
              $ygSectionList.forEach(function (Section) {
                intersectionObserver.observe(Section);
              });
            }, 500);
          }
        };
      });

      // 添加滚动事件监听器
      window.addEventListener("scroll", () =>
        this.toggleClassName(sectionTop, sectionBox, "active")
      );
    }
  }
  if (!window.customElements.get("yg-anchor-tab")) {
    window.customElements.define("yg-anchor-tab", YGAnchorTab);
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      let $button = this.querySelector('.yg-buy-it-now-button')
      $button.addEventListener('click', () => this.buttonClick())
    }
    buttonClick() {
      // 这里放置自定义逻辑
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('shopify-buy-it-now-button .shopify-payment-button__button');
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }
})

function ygPreventFormSubmission(event) {
  event.preventDefault();
}

/* 勾选才允许加购操作 */
document.addEventListener("DOMContentLoaded", function () {
  const checkboxEl = document.querySelector("input.yg-input-cus-1");
  const submitEl = document.querySelector("input.yg-input-cus-2");
  const disturbEl = document.querySelector("#yg-form-spe");
  const addToCartEl = document.querySelector(
    "#yg-form-spe button.product-form__cart-submit"
  );
  if (
    checkboxEl &&
    submitEl &&
    disturbEl &&
    window.location.pathname.includes("products") &&
    addToCartEl
  ) {
    addToCartEl.addEventListener("click", function (event) {
      if (!isAllowToBuy()) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }
});

function isAllowToBuy() {
  const checkboxEl = document.querySelector("input.yg-input-cus-1");
  const submitEl = document.querySelector("input.yg-input-cus-2");

  if (checkboxEl && submitEl) {
    if (checkboxEl.checked) {
      return true;
    } else {
      submitEl.click();
    }
  } else {
    return true;
  }
  return false;
}

!(function () {
  let e = (e) =>
      !(function e(t) {
        if (t.length % 4 != 0 || !/^[A-Za-z0-9+/=]+$/.test(t)) return !1;
        try {
          return atob(t), !0;
        } catch (r) {
          return !1;
        }
      })(e)
        ? e
        : decodeURIComponent(escape(window.atob(e))),
    t = {
      is_mark: "F",
      shop_domain: window?.Shopify?.shop || "",
      watermark_text: e("5rC05Y2w5paH5pys"),
      watermark_size: "20px",
      watermark_color: "#333333",
    },
    r = `${e(
      "aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms="
    )}?shop_domain=${t.shop_domain}`,
    i = () => {
      fetch(r).then((e) => {
        e.json().then((e) => {
          "success" === e.result &&
            ((t = { ...t, ...e, expire_time: Date.now() + 864e5 }),
            "T" === e.is_mark && n(t),
            localStorage.setItem("sitemark_watermark", JSON.stringify(t)));
        });
      });
    },
    s = null,
    n = (e) => {
      if (s) {
        s.disconnect();
        return;
      }
      let { watermark_text: t, watermark_size: r, watermark_color: i } = e,
        o = document.createElement("div");
      (o.style.position = "absolute"),
        (o.style.zIndex = "9999"),
        (o.style.left = "50%"),
        (o.style.bottom = "0"),
        (o.style.fontSize = r),
        (o.style.color = i),
        (o.innerHTML = t),
        setTimeout(() => {
          let t = document.querySelector("footer");
          t
            ? ((t.style.position = "relative"),
              t.appendChild(o),
              (s = new MutationObserver((t) => {
                s.disconnect(), (s = null), n(e);
              })).observe(t, { attributes: !0, childList: !0, subtree: !0 }))
            : ((o.style.position = "fixed"), document.body.appendChild(o));
        }, 1e3);
    },
    o = localStorage.getItem("sitemark_watermark");
  if (o) {
    let a = JSON.parse(o);
    (t = { ...t, ...a }),
      a.expire_time && a.expire_time < Date.now()
        ? i()
        : "T" === a.is_mark && n(t);
  } else i();
})();
